<template lang="html">
  <div class="numeral">
    <div v-html="question.title" class="col-form-label pt-0 form-group title-numeral-question" style="padding-bottom: 0.75rem; text-align: justify;padding-right: 0.9rem;"></div>
    <b-form-group>
      <b-form-radio-group id="radio-group-2" v-model="selected" name="radio-sub-component" @input="changeStep(); changeStepAuto()">
        <b-row class="justify-content-md-center">
        <div class="center numeral-cols">
          <b-form-radio :value="question.options[4]" :class="{'activeRadio': question.value === '1'}"><span>1</span></b-form-radio>
        </div >
        <div class="center numeral-cols">
          <b-form-radio :value="question.options[3]" :class="{'activeRadio': question.value === '2'}"><span>2</span></b-form-radio>
        </div>
        <div class="center numeral-cols">
          <b-form-radio :value="question.options[2]" :class="{'activeRadio': question.value === '3'}"><span>3</span></b-form-radio>
        </div>
        <div class="center numeral-cols">
          <b-form-radio :value="question.options[1]" :class="{'activeRadio': question.value === '4'}"><span>4</span></b-form-radio>
        </div>
        <div class="center numeral-cols">
          <b-form-radio :value="question.options[0]" :class="{'activeRadio': question.value === '5'}"><span>5</span></b-form-radio>
        </div>
        </b-row>
      </b-form-radio-group>
      <b-row class="sub-titles-numeral">
        <div class="center titles-numeral">
          <p class="text-center">
            {{question.options.length > 0 ? question.options[4].title : 'Nada satisfecho'}}
          </p> 
        </div>
        <div class="center titles-numeral hidden-sub-titles" >
          <p class="text-center">
            {{question.options.length > 0 ? question.options[3].title : 'Poco satisfecho'}} 
          </p>
        </div>
        <div class="center titles-numeral hidden-sub-titles">
          <p class="text-center">
            {{question.options.length > 0 ? question.options[2].title : 'Satisfecho'}}
          </p>
        </div>
        <div class="center titles-numeral hidden-sub-titles">
          <p class="text-center">
             {{question.options.length > 0 ? question.options[1].title : 'Muy satisfecho'}} 
          </p>
        </div>
        <div class="center titles-numeral" >
          <p class="text-center">
            {{question.options.length > 0 ? question.options[0].title : 'Totalmente satisfecho'}}
          </p>  
        </div>
      </b-row>
    </b-form-group>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';

export default {
  props: {
    question: {
      type: Object,
      required: true
    },
    defaultValue: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      selected: null,
      options_formatted: [],
    };
  },
  mounted () {
    if (this.defaultValue !== null) {
      let _self = this;
      this.selected = this.question.options.filter(function (option) {
        return option.value === _self.defaultValue;
      })[0];
    }
  },
  methods: {
    changeStep () {
      this.question.value = this.selected.value;
      /* send object and with value, next Question id and previus, and set value in json reactive */ 
    
      this.$emit('change-step', {
        nextQuestionId: this.selected.next_question_id, 
        previusQuestionId: this.selected.previus_question_id
      });
    },
    changeStepAuto () {
      this.$emit('change-step-auto');
    }
  }
};
</script>

<style lang="css">
  .numeral {
    width: 100%;
  }
  .numeral-cols {
    width: 20%;
  }
  .numeral .custom-control{
    padding-left: 10px;
  }
  .numeral .custom-control-label{
    width: 3.5rem;
    height: 3.5rem;
  }
  .numeral .col-form-label{
    margin-bottom: 1rem;
    font-size: 20px;
    font-weight: bold;
  }
  .numeral .custom-control-label span{
    position: absolute;
    width: 3.5rem;
    height: 3.5rem;
    left: 0;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    font-size: 1.1rem;
    font-size: 20px;
  }
  .numeral .custom-control-label{
    display: flex;
    align-items: flex-end;
    position: relative;
  }
  .numeral .custom-control-label::before {
    width: 3.5rem;
    height: 3.5rem;
    left: 50%;
    margin-left: -1.75rem;
    top: 0;
  }
  .numeral .custom-control-label::after {
    background-size: 80%;
    margin-left: -.5rem;
    top: .5rem;
    left: 50%;
  }
  .numeral .custom-radio .custom-control-input:checked ~ .custom-control-label::after {
    background-image: none;
  }
  .numeral .custom-radio .custom-control-input:checked ~ .custom-control-label span {
    color: #fff;
  }
  .numeral .custom-radio.activeRadio  .custom-control-label::before {
    background-color: #007bff;
  }
  .numeral .custom-radio.activeRadio  .custom-control-label span {
    color: #fff;
  }
  .numeral .custom-radio .custom-control-label::before {
    background-color: #f0f2f4;
  }
  .titles-numeral{
    width: 20%;
    font-size: 0.8rem;
    text-align: center;
  }
  @media only screen and (orientation: portrait) and (max-width: 475px)  {
    .numeral .custom-radio .custom-control-label::before {
      background-color: #f0f2f4;
      width: 2.8rem;
      height: 2.8rem;
    }
    .numeral .custom-control-label span{
      position: absolute;
      width: 2.2rem;
      height: 2.6rem;
      left: 0;
      top: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: bold;
      font-size: 16px;
    }
    .titles-numeral{
      width: 19%;
      font-size: 11px;
      text-align: center;
    }
    .row .justify-content-md-center{
      padding: 0px 15px 0px 15px;
    }
    .numeral .custom-control-label{
      width: 2.8rem;
      height: 2.8rem;
    }
    .sub-titles-numeral {
      padding: 0px 5px 0px 13px;
      line-height: 12px;
    }
    .numeral .col-form-label{
      margin-bottom: 1rem;
      font-size: 12px;
      font-weight: bold;
    }
    .hidden-sub-titles{
      /*color: transparent;*/
    }
    .numeral .custom-control-inline{
      margin-left: 0px;
    }

  }

</style>



// WEBPACK FOOTER //
// src/surveys/v2/components/Numeral.vue